import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import FAQSection from './components/FAQSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <MediaSection />
        <FeaturesSection />
        <FAQSection />
        <CommentsSection />
        <CarouselSection />
        <AppSection />
        <IndexSection />
        <RankingSection />
        <TopicsSection />
        <UpdatesSection />
        <CardsSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}